// extracted by mini-css-extract-plugin
export default {"table":"table-module--table--6031c","extendedTable":"table-module--extendedTable--06154"};